<ng-container *ngTemplateOutlet="templateRef; context: { $implicit: entry }"></ng-container>
